import { ApiStatusError } from '@nutralab/api';

import {
    type AuthActionResult,
    login,
    registerComplete,
    registerRequest,
    resetPasswordRequest,
    resetPasswordVerify,
} from '@/shared/api/actions/auth';

async function unwrap<T>(result: Promise<AuthActionResult<T>>): Promise<T> {
    const response = await result;
    if (response.success) {
        return response.data;
    }
    throw new ApiStatusError(response.status, response.body);
}

/**
 * Sign-in, registration and password reset over the server actions in `shared/api/actions/auth`, with the same
 * signatures and errors as `browserApi.auth`: a failure throws `ApiStatusError`, so `getAuthMnemonicFromError` works.
 * The token refresh, sign-out, profile and password change stay on `browserApi` (they carry the user's token).
 */
export const storefrontAuth = {
    login: (...args: Parameters<typeof login>) => unwrap(login(...args)),
    registerRequest: (...args: Parameters<typeof registerRequest>) => unwrap(registerRequest(...args)),
    registerComplete: (...args: Parameters<typeof registerComplete>) => unwrap(registerComplete(...args)),
    resetPasswordRequest: (...args: Parameters<typeof resetPasswordRequest>) => unwrap(resetPasswordRequest(...args)),
    resetPasswordVerify: (...args: Parameters<typeof resetPasswordVerify>) => unwrap(resetPasswordVerify(...args)),
};
